import React from "react";
import "./Faq.css";

export const Faq = () => {
  return (
    <div id="faq" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Frequently Asked Questions</h2>
          <p>
            Common questions about PERM recruitment advertising and our services
          </p>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <div className="faq-item">
              <h3>What is PERM recruitment advertising?</h3>
              <p>
                PERM (Program Electronic Review Management) recruitment advertising refers to the advertising efforts required by the Department of Labor (DOL) as part of the labor certification process for employers seeking to sponsor foreign workers for permanent residency in the United States. These advertisements are designed to test the labor market to ensure that there are no qualified U.S. workers available for the position before hiring a foreign worker.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>What types of advertisements are required for PERM?</h3>
              <p>
                The Department of Labor requires several recruitment steps for PERM applications, including:
              </p>
              <ul className="faq-list">
                <li>Two Sunday newspaper advertisements in the newspaper of general circulation in the area of intended employment</li>
                <li>Posting a job order with the State Workforce Agency for at least 30 days</li>
                <li>Three additional recruitment steps from a list of options (e.g., job fairs, employer's website, job search websites, on-campus recruiting, etc.)</li>
              </ul>
              <p>
                Professional positions may require additional advertising in professional journals or other industry-specific publications.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>How long does the PERM advertising process take?</h3>
              <p>
                The PERM recruitment process typically takes about 2-3 months to complete. This includes the time needed to place all required advertisements, maintain the job posting for the required period, and allow for a 30-day "cooling off" period after the last advertisement before filing the PERM application. However, the entire PERM process, including preparation and DOL processing, can take 6-12 months or longer.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>What information must be included in PERM advertisements?</h3>
              <p>
                PERM advertisements must include:
              </p>
              <ul className="faq-list">
                <li>The employer's name</li>
                <li>Instructions for submitting resumes or applications</li>
                <li>A description of the position specific enough to apprise potential applicants of the job opportunity</li>
                <li>The geographic location of the job</li>
              </ul>
              <p>
                The advertisements should not include requirements that exceed what is normal for the occupation or any requirements that foreign workers may satisfy but U.S. workers cannot.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>Why should I use a specialized agency for PERM advertising?</h3>
              <p>
                Using a specialized agency like ADS 4 PERM for your PERM advertising needs offers several advantages:
              </p>
              <ul className="faq-list">
                <li>Expertise in DOL requirements and regulations</li>
                <li>Time and cost savings through efficient ad placement</li>
                <li>Proper documentation for PERM applications</li>
                <li>Reduced risk of application denial due to advertising errors</li>
                <li>Access to a wide range of advertising options and media outlets</li>
              </ul>
            </div>
            
            <div className="faq-item">
              <h3>What documentation do I need to keep for my PERM application?</h3>
              <p>
                For your PERM application, you should maintain:
              </p>
              <ul className="faq-list">
                <li>Copies of all print advertisements (tear sheets)</li>
                <li>Screenshots of online job postings with visible dates</li>
                <li>Documentation of the State Workforce Agency job order</li>
                <li>Proof of additional recruitment steps</li>
                <li>A recruitment report summarizing all applicants and reasons for rejection</li>
                <li>All resumes received and correspondence with applicants</li>
              </ul>
              <p>
                ADS 4 PERM provides comprehensive documentation packages for all advertising services we provide.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>Can I place PERM advertisements myself?</h3>
              <p>
                While employers can technically place PERM advertisements themselves, using a specialized agency ensures compliance with all DOL requirements. The PERM process is highly technical, and even minor errors in advertising can lead to application denials. Our expertise helps navigate these complexities and provides proper documentation for your application.
              </p>
            </div>
            
            <div className="faq-item">
              <h3>How much does PERM advertising cost?</h3>
              <p>
                The cost of PERM advertising varies depending on the geographic location, types of media used, and specific requirements of your position. Newspaper advertisements in major metropolitan areas can be costly, while online advertisements may be more affordable. Contact us for a customized quote based on your specific needs and location.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
